import React from 'react';

import { 
  Box, 
  Typography
} from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PivotTableChartOutlinedIcon from '@mui/icons-material/PivotTableChartOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import ViewHeadlineOutlinedIcon from '@mui/icons-material/ViewHeadlineOutlined';
import ViewStreamOutlinedIcon from '@mui/icons-material/ViewStreamOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import SegmentOutlinedIcon from '@mui/icons-material/SegmentOutlined';
import FilterFramesOutlinedIcon from '@mui/icons-material/FilterFramesOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';

import "../styles.scss";

const CoreTradeDefence = ({
  navigate, 
  currentPage
}) => {
  return (
    <Box className="nav__side-common flex__Column" 
      display={"flex"} flexDirection={"column"} gap={"10px"}>
      <Box className="nav__side-container">
        <Box className={`nav__side-item flexCenter_Row`}
          onClick={() => {
            navigate("/business/core");
          }}>
          <ArrowBackIcon />
          <Typography variant='body2'>
            Back
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Core Entities & Configuration</i>
      </Typography>

      <Box className="nav__side-container">
        <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/brokers");
          }}>
          <HandshakeOutlinedIcon />
          <Typography variant='body2'>
            Brokers
          </Typography>
        </Box>
        <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/compliance-vectors");
          }}>
          <VerifiedUserOutlinedIcon />
          <Typography variant='body2'>
            Compliance Vectors
          </Typography>
        </Box>
        <Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/company-vector-pref");
          }}>
          <TuneOutlinedIcon />
          <Typography variant='body2'>
            Company Vector Pref
          </Typography>
        </Box>
        <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/system-validation-rules");
          }}>
          <RuleOutlinedIcon />
          <Typography variant='body2'>
            System Validation Rules
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Statutory Reference Data</i>
      </Typography>

      <Box className="nav__side-container">
        <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/usitc-hts-codes");
          }}>
          <LocalOfferOutlinedIcon />
          <Typography variant='body2'>
            USITC HTS Codes
          </Typography>
        </Box>
        <Box className={`${currentPage === 5 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/ustr-exclusions");
          }}>
          <DoNotDisturbOnOutlinedIcon />
          <Typography variant='body2'>
            USTR Exclusions
          </Typography>
        </Box>
        <Box className={`${currentPage === 19 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/usitc-revisions");
          }}>
          <CalendarMonthOutlinedIcon />
          <Typography variant='body2'>
            USITC Revisions
          </Typography>
        </Box>
        <Box className={`${currentPage === 20 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/usitc-spi-rates");
          }}>
          <PercentOutlinedIcon />
          <Typography variant='body2'>
            USITC SPI Rates
          </Typography>
        </Box>
        <Box className={`${currentPage === 21 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/usitc-chapter99-mappings");
          }}>
          <AccountTreeOutlinedIcon />
          <Typography variant='body2'>
            Chapter 99 Mappings
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Chapter 99 Structural Substrate</i>
      </Typography>

      <Box className="nav__side-container">
        <Box className={`${currentPage === 28 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-node-visualizer");
          }}>
          <SchemaOutlinedIcon />
          <Typography variant='body2'>
            SC Node Visualizer
          </Typography>
        </Box>
        <Box className={`${currentPage === 22 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-nodes");
          }}>
          <SchemaOutlinedIcon />
          <Typography variant='body2'>
            SC Nodes
          </Typography>
        </Box>
        <Box className={`${currentPage === 23 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-node-content");
          }}>
          <DescriptionOutlinedIcon />
          <Typography variant='body2'>
            SC Node Content
          </Typography>
        </Box>
        <Box className={`${currentPage === 24 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-node-revision-status");
          }}>
          <CompareArrowsOutlinedIcon />
          <Typography variant='body2'>
            SC Node Revision Status
          </Typography>
        </Box>
        <Box className={`${currentPage === 25 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-segmentation-runs");
          }}>
          <SegmentOutlinedIcon />
          <Typography variant='body2'>
            SC Segmentation Runs
          </Typography>
        </Box>
        <Box className={`${currentPage === 26 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-page-furniture-log");
          }}>
          <FilterFramesOutlinedIcon />
          <Typography variant='body2'>
            SC Page Furniture Log
          </Typography>
        </Box>
        <Box className={`${currentPage === 27 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/ch99-ingest");
          }}>
          <FileUploadOutlinedIcon />
          <Typography variant='body2'>
            Ch99 PDF Ingestion
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Ch99 Rule Engine</i>
      </Typography>

      <Box className="nav__side-container">
        <Box className={`${currentPage === 30 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/ch99-rule-engine");
          }}>
          <GavelOutlinedIcon />
          <Typography variant='body2'>
            Rule Engine
          </Typography>
        </Box>
        <Box className={`${currentPage === 31 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-ch99-rules");
          }}>
          <RuleOutlinedIcon />
          <Typography variant='body2'>
            SC Ch99 Rules
          </Typography>
        </Box>
        <Box className={`${currentPage === 32 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-rule-interactions");
          }}>
          <CompareArrowsOutlinedIcon />
          <Typography variant='body2'>
            SC Rule Interactions
          </Typography>
        </Box>
        <Box className={`${currentPage === 33 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/sc-hts-ch99-mappings");
          }}>
          <AccountTreeOutlinedIcon />
          <Typography variant='body2'>
            SC HTS-Ch99 Mappings
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Tools</i>
      </Typography>

      <Box className="nav__side-container">
        <Box className={`${currentPage === 29 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/tariff-simulator");
          }}>
          <CalculateOutlinedIcon />
          <Typography variant='body2'>
            Tariff Simulator
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Assembly Pipeline (Pre-Staging)</i>
      </Typography>

      <Box className="nav__side-container">
        <Box className={`${currentPage === 17 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/assembly-sessions");
          }}>
          <StorageOutlinedIcon />
          <Typography variant='body2'>
            Assembly Sessions
          </Typography>
        </Box>
        <Box className={`${currentPage === 18 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/assembly-documents");
          }}>
          <FolderOpenOutlinedIcon />
          <Typography variant='body2'>
            Assembly Documents
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Ingestion Pipeline (Staging Area)</i>
      </Typography>

      <Box className="nav__side-container">
        <Box className={`${currentPage === 6 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/staging-entries");
          }}>
          <PublishOutlinedIcon />
          <Typography variant='body2'>
            Staging Entries
          </Typography>
        </Box>
        <Box className={`${currentPage === 7 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/staging-documents");
          }}>
          <PostAddOutlinedIcon />
          <Typography variant='body2'>
            Staging Documents
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Transactional Ledger (The Entry)</i>
      </Typography>
      
      <Box className="nav__side-container">
        <Box className={`${currentPage === 8 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/customs-entries");
          }}>
          <LocalShippingOutlinedIcon />
          <Typography variant='body2'>
            Customs Entries
          </Typography>
        </Box>
        <Box className={`${currentPage === 9 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/entry-documents");
          }}>
          <ArticleOutlinedIcon />
          <Typography variant='body2'>
            Entry Documents
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Structured Document Data (Master/Detail)</i>
      </Typography>
      
      <Box className="nav__side-container">
        <Box className={`${currentPage === 10 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/pivot-masters");
          }}>
          <PivotTableChartOutlinedIcon />
          <Typography variant='body2'>
            Pivot Masters
          </Typography>
        </Box>
        <Box className={`${currentPage === 11 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/pivot-rows");
          }}>
          <TableRowsOutlinedIcon />
          <Typography variant='body2'>
            Pivot Rows
          </Typography>
        </Box>
        <Box className={`${currentPage === 12 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/ci-masters");
          }}>
          <SummarizeOutlinedIcon />
          <Typography variant='body2'>
            CI Masters
          </Typography>
        </Box>
        <Box className={`${currentPage === 13 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/ci-lines");
          }}>
          <FormatListBulletedOutlinedIcon />
          <Typography variant='body2'>
            CI Lines
          </Typography>
        </Box>
        <Box className={`${currentPage === 14 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/form-7501-headers");
          }}>
          <ViewHeadlineOutlinedIcon />
          <Typography variant='body2'>
            Form 7501 Headers
          </Typography>
        </Box>
        <Box className={`${currentPage === 15 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/form-7501-lines");
          }}>
          <ViewStreamOutlinedIcon />
          <Typography variant='body2'>
            Form 7501 Lines
          </Typography>
        </Box>
        <Box className={`${currentPage === 16 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/trade-defence/bol-headers");
          }}>
          <ReceiptLongOutlinedIcon />
          <Typography variant='body2'>
            BOL Headers
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default CoreTradeDefence;